<template>
	<div>
		<!-- ------------------------------忘記帳號開始------------------------------ -->
        <div class="modal fade cm-modal" id="forgotAccountModal" tabindex="-1" role="dialog"
            aria-labelledby="forgotAccountModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header text-center cm-modal-forgot-header p-0">
                        <h4 class='col-12 modal-title text-center p-0 m-0 row'>
                            <div class="col-6 cm-modal-href">
                                <a href="#" class="text-center d-block w-100" data-toggle="modal"
                                    data-target="#forgotPasswordModal">{{$t('modal.ForgotPassword.Title')}}</a>
                            </div>
                            <div class="col-6 cm-modal-title">
                                {{$t('modal.ForgotAccount.Title')}}
                                <button type="button" class="close cm-forgot-close" data-dismiss="modal"
                                    aria-label="Close">
                                    <img src="@/assets/images/login-close.png">
                                </button>
                            </div>
                        </h4>
                    </div>
                    <div class="modal-body p-md-5 p-3 cm-modal-forgot-body">
                        <div>
                            <span>
                                {{$t('modal.ForgotAccount.Content')}}
                            </span>
                        </div>
                        <div class="pt-3">
                            <input v-model="email" v-on:blur="emailMonitor" type="text" class="form-control" :placeholder="$t('modal.ForgotAccount.Placeholder.RegisteredEmail')">
                            <label class="text-danger" v-if="emailPromptString !== ''"  v-html="emailPromptString"></label>
                        </div>
                        <div class="col py-2">
                            <div v-if="isWaitingSendEmailToTellAccountAjax==true" class="spinner-border text-warning text-center d-block mx-auto" role="status"></div>
                            <button v-if="isWaitingSendEmailToTellAccountAjax==false" @click="submitBtn" type="button" class="btn btn-lg text-white cm-forgot-send-button">{{$t('modal.ForgotAccount.Confirm')}}</button>
                        </div>
                        <img src="@/assets/images/cmi_logo_black.png" class="cm-forgot-logo-img">
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------忘記帳號結束------------------------------ -->
	</div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js";
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'
export default {
    data() {
        return {
            email: "",
            emailPromptString: "",
            isWaitingSendEmailToTellAccountAjax: false
        }
    },
    mounted() {
        const self = this;
        $('#forgotAccountModal').on('hidden.bs.modal', function () {
            self.resetData();
        })
    },
    methods: {
        resetData() {
            this.email = "";
            this.emailPromptString = "";
        },
        async emailMonitor() {
            this.emailPromptString = ""
            if(this.email == "") {
                this.emailPromptString = "*" + this.$i18n.t('modal.ForgotAccount.Prompt.Input.RegisteredEmail');
            }
            else if(ValidatorUtil.validEmail(this.email) != "") {
                this.emailPromptString = "*" + this.$i18n.t('modal.ForgotAccount.Prompt.Input.Format');
            }
        },
        async submitBtn() {
            this.emailMonitor()
            if(this.emailPromptString == "") {
                RecaptchaUtil.startGoogleRecaptchaVerify(process.env.VUE_APP_AUTH_RECAPTCHA_FORGOT_ACCOUNT, this.ajaxSendEmailToTellAccountAction);
            }
        },
        async ajaxSendEmailToTellAccountAction(gRecaptchaResponse) {
            this.isWaitingSendEmailToTellAccountAjax = true;
            let bodyFormData = new FormData();
            bodyFormData.append("email", this.email);
            bodyFormData.append("request_locale", this.$i18n.locale.replace("-", "_"));
            bodyFormData.append("mydomain", "all9fun.com");
            bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);

            const self = this;
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/sendEmailToTellAccountAction.shtml",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                data: bodyFormData
            })
            .catch(function() {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            })

            this.isWaitingSendEmailToTellAccountAjax = false;

            // 判斷Ajax結果
            if(response!=undefined && response.data!=undefined) {
                if(response.data.result=="success") {
                    alert(self.$i18n.t('modal.ForgotAccount.Backend.Response.Success'));
                }
                else if(response.data.result=="emailNotFound") {
                    alert(self.$i18n.t('modal.ForgotAccount.Backend.Response.MailNotExist'));
                }
                else {
                    alert(self.$i18n.t('modal.ForgotAccount.Backend.Response.Failed'));
                }
            }
        }
    },
}
</script>